/**
 * User-facing copy.
 *
 * Centralised so the same failure reads the same way everywhere, and so
 * translating later means editing one file rather than hunting strings through
 * components.
 */
export const ERRORS = {
  generic: 'Something went wrong. Please try again.',
  network: 'Could not reach the server. Check your connection and try again.',
  unauthorized: 'Your session has ended. Please sign in again.',
  forbidden: 'You do not have access to that.',
  notFound: 'We could not find what you were looking for.',
  rateLimited: 'Too many attempts. Please wait a moment and try again.',
  invalidCredentials: 'That email or password is not correct.',
  accountLocked: 'This account is locked. Please contact NμDent support.',
  resetCodeInvalid: 'That code is not correct or has expired. Check the email, or send a new code.',
  resetExpired: 'This reset has expired. Please request a new code.',
  passwordIncorrect: 'That password is not correct.',
} as const;

export const SUCCESS = {
  signedIn: 'Signed in.',
  signedOut: 'Signed out.',
  passwordReset: 'Password updated. Sign in with your new password.',
  saved: 'Saved.',
} as const;

export const LABELS = {
  signIn: 'Sign in',
  signOut: 'Sign out',
  email: 'Email',
  password: 'Password',
  loading: 'Loading',
} as const;

/**
 * The signed-out screen's pitch, shared by the sign-in and reset pages.
 *
 * No badge: ADMIN and PRODUCTION tell staff which console they are in, but a
 * customer only ever has this portal, and the word read as a label on them.
 */
export const CUSTOMER_AUTH_COPY = {
  headline: 'Your licence, your seats, your support history.',
  blurb: 'Sign in with the email address your NμDent licence was issued to.',
} as const;
